module.exports = __webpack_public_path__ + "img/empty-data.2e163039.png";